export const cilChartLine = ["24 24","<path d='M17.625 7.5v1.5h3.064l-8.877 8.877-3.375-3.375-4.843 4.843 1.061 1.061 3.782-3.782 3.375 3.375 9.938-9.937v3.064h1.5v-5.625h-5.625z'></path><path d='M2.25 4.875h-1.5v18.375h22.5v-1.5h-21v-16.875z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-chart-line.js
// module id = null
// module chunks = 